import styled from 'styled-components';
import { animated } from 'react-spring/renderprops.cjs';
import { X } from 'react-feather';
import { space, color, width } from 'styled-system';
import { theme } from '../../theme';

export const ModalWrap = styled(animated.div)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${theme.zIndex[12]};
  height: 100vh;
  display: flex;
  position: fixed;
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

type CustomModalInnerProps = {
  bg?: string;
};

type ModalBodyContProps = {
  hasAction?: boolean;
};

export const ModalInner = styled(animated.div)<any>`
  ${space};
  ${color};
  ${width};
  display: flex;
  max-width: 100%;
  min-width: 500px;
  max-height: 100%;
  border-radius: 5px;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
`;

export const CustomModalInner = styled(animated.div)<CustomModalInnerProps>`
  width: auto;
  width: auto;
  display: flex;
  max-width: 100%;
  border-radius: 5px;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.bg || 'transparent'};
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
`;

export const ModalHeaderCont = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 10px;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-start;
  border-bottom: 1px solid #f1f7fb;
  padding-left: 15px;
  padding-right: 15px;
`;

export const ModalBodyCont = styled.div<ModalBodyContProps>`
  width: 100%;
  display: flex;
  padding-bottom: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-start;
  max-height: 80vh;
  overflow-y: auto;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: ${props => (props.hasAction ? 'none' : '1px solid #f1f7fb')};
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.putty};
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 5px;
  }
`;

export const ModalChildrenBodyContent = styled.div`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-start;
  max-height: 80vh;
  overflow-y: auto;
  padding-left: 15px;
  padding-right: 15px;
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.putty};
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 5px;
  }
`;

export const ModalFooterCont = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const CloseButton = styled(X)<any>`
  right: 20px;
  width: 20px;
  height: 20px;
  z-index: ${theme.zIndex[13]};
  font-size: 40px;
  position: absolute;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.9);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const CloseButtonZero = styled(X)<any>`
  right: 0;
  width: 20px;
  height: 20px;
  z-index: ${theme.zIndex[13]};
  font-size: 40px;
  position: absolute;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.9);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;



// WEBPACK FOOTER //
// ./src/components/modal/Elements.tsx